import { render, staticRenderFns } from "./ChannelLink.vue?vue&type=template&id=11abf810&scoped=true&"
import script from "./ChannelLink.vue?vue&type=script&lang=js&"
export * from "./ChannelLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11abf810",
  null
  
)

export default component.exports